import { useRef, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { getYoutubeVideoId } from './linkUtils.js';
import { jsx } from 'react/jsx-runtime';

/**
 * Youtube's IFrame API player, necessary on mobile devices as autoplay for Youtube does not work using normal embed IFrame.
 */
function PlayerFrameWithYoutubeApi({
  src
}) {
  const ref = useRef(null);
  const loadVideo = useCallback(() => {
    const videoId = getYoutubeVideoId(src);
    new window.YT.Player(ref.current, {
      videoId,
      events: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
        onReady: event => event.target.playVideo()
      }
    });
  }, [src]);
  useEffect(() => {
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';

      // onYouTubeIframeAPIReady will load the video after the script is loaded
      window.onYouTubeIframeAPIReady = loadVideo;
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag?.parentNode?.insertBefore(tag, firstScriptTag);
    } else {
      loadVideo();
    }
  }, [loadVideo]);
  return /*#__PURE__*/jsx(Container, {
    children: /*#__PURE__*/jsx("div", {
      ref: ref
    })
  });
}

// eslint-disable-next-line @cbhq/theme-no-static-value -- TODO Fix this
const Container = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;

  iframe {
    width: 100%;
    height: 100%;
  }
`;
export { PlayerFrameWithYoutubeApi };
//# sourceMappingURL=PlayerFrameWithYoutubeApi.js.map
